import { Reducer } from 'redux';
import { KpiSATypes, KpiSAState } from './types';

const INITIAL_STATE: KpiSAState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<KpiSAState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case KpiSATypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case KpiSATypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case KpiSATypes.LOAD_FAILURE:
      return { ...state, loading: false, error: true, data: INITIAL_STATE.data };
    default:
      return state;
  }
};

export default reducer;
